import { Injectable } from '@angular/core';
import { DvSplitterEventsService } from '@devinco/ui/dds/splitter';
import { AgGridAngular } from 'ag-grid-angular';

@Injectable({ providedIn: 'root' })
export class VtSplitterService extends DvSplitterEventsService {
  private _agGrid: AgGridAngular;

  get agGrid(): AgGridAngular {
    return this._agGrid;
  }
  set agGrid(agGrid: AgGridAngular) {
    this._agGrid = agGrid;
  }
}
